import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--dropdown"
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)

    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)

    this.boundCloseOthers = this.closeIfNotSelf.bind(this)
    document.addEventListener("ui--dropdown:opened", this.boundCloseOthers)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("ui--dropdown:opened", this.boundCloseOthers)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    document.dispatchEvent(new CustomEvent("ui--dropdown:opened", { detail: { controller: this } }))
    this.menuTarget.classList.remove("hidden")
  }

  closeIfNotSelf(event) {
    if (event.detail.controller !== this) {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (!this.menuTarget.classList.contains("hidden")) {
      switch (event.key) {
        case "Escape":
          this.close()
          break
        case "ArrowDown":
          event.preventDefault()
          this.focusNextItem()
          break
        case "ArrowUp":
          event.preventDefault()
          this.focusPreviousItem()
          break
      }
    }
  }

  focusNextItem() {
    const items = this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled])')
    const currentIndex = Array.from(items).indexOf(document.activeElement)
    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0
    items[nextIndex]?.focus()
  }

  focusPreviousItem() {
    const items = this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled])')
    const currentIndex = Array.from(items).indexOf(document.activeElement)
    const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1
    items[prevIndex]?.focus()
  }
}
